export default __webpack_public_path__ + "static/media/large.42de17ed.jpg";